import { Component, Input, OnInit,AfterViewInit,ViewEncapsulation, ViewChild  } from '@angular/core';
import { SwiperConfigInterface } from 'ngx-swiper-wrapper';
import { TopProductsComponent } from '../../shared/top-products/top-products.component';
import { Router } from '@angular/router';
import { UserService } from '../../shared/services/user.service';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
  encapsulation: ViewEncapsulation.None 
})
export class homeComponent implements OnInit,AfterViewInit  {
  public config: SwiperConfigInterface = {};
  @ViewChild(TopProductsComponent) topProductComponent!: TopProductsComponent;
  @ViewChild('heroVideo', { static: false }) heroVideo!: any;

  vimeoEmbedUrl: any;
  testimonialVimeoEmbedUrl: any;

  constructor(
    public router: Router,
    public userService: UserService,
    private sanitizer: DomSanitizer
  ) { }
  @Input() displayProducts = [
    {
      img: "../../../../assets/images/productRating/product1.png",
      startext:
        "Sometimes Change is necessary and I found mine here.",
      author: "DR. JACOB",
      type: "Customer",
      small: true,
      medium: false,
      left: false,
      leftbig: false,
      boxTitle: 'TANGERINE FUN',
      boxContent: 'Loyalty Rewards'
    },
    {
      img: "../../../../assets/images/productRating/product2.png",
      startext:
        "I thank God I found a company that cares more about it's distributor's and customers than it does about itself.",
      author: "PAULA WANGNER",
      type: "Customer",
      small: true,
      medium: false,
      left: false,
      leftbig: false,
      boxTitle: 'TANGERINE FUN',
      boxContent: 'Loyalty Rewards'
    },
    {
      img: "../../../../assets/images/productRating/product3.png",
      startext:
        "Super products, especially now when we need to keep our immune system strong!",
      author: "DR. KARL ANDERSON",
      type: "BrainSense",
      small: true,
      medium: false,
      left: false,
      leftbig: false,
      boxTitle: 'TANGERINE FUN',
      boxContent: 'Loyalty Rewards'
    },
    {
      img: "../../../../assets/images/productRating/product1.png",
      startext:
        "This is the best tasting mangosteen drink I have tried. I crave it everyday.",
      author: "ROBIN",
      type: "Customer",
      small: true,
      medium: false,
      left: false,
      leftbig: false,
      boxTitle: 'TANGERINE FUN',
      boxContent: 'Loyalty Rewards'
    },
   ];

  // Scrolling banner data
  scrollContent: any[] = [];
  secondScrollContent: any[] = [];

  // Products data - Updated with proper product URLs
  products: any[] = [
    {
      id: 1,
      name: "Metabology™ Matrix",
      price: "$319.96",
      rv: "125 RV",
      description: "Energize by day, recharge by night, and glow in between. This complete set supports your metabolism 24/7—fueling vitality, clarity, and skin-deep renewal.",
      image: "https://ik.imagekit.io/fluid/980191229/images/XDKZYP/XDKZYP_gJ73ttT7Sx.png",
      variant: 'green',
      url: '/www/product?id=metabology-matrix-idTF1-MMP-715'
    },
    {
      id: 2,
      name: "Metabology™ Ω3",
      price: "$79.99",
      rv: "35 RV",
      description: "Metabology Ω3 provides heart-healthy omega-3s (EPA & DHA) to support cardiovascular health and brain function, while astaxanthin and rosemary enhance antioxidant protection and joint comfort. With a clean lemon flavor, it delivers daily vitality without compromise.",
      image: "https://ik.imagekit.io/fluid/980191229/images/C9ZZQ7/C9ZZQ7_Setn9R5IK.png",
      variant: 'yellow',
      url: '/www/product?id=metabology%E2%84%A2-%CF%893-idMETA-OM-103'
    },
    {
      id: 3,
      name: "Metabology™ Lean",
      price: "$79.99",
      rv: "35 RV",
      description: "Precision-crafted thermogenic support for the body—and life—you're building. With targeted nutrients to ignite fat metabolism, balance blood sugar, and curb cravings, Metabology Lean helps you stay energized, focused, and in flow. It's not just about getting lean—it's about living aligned.",
      image: "https://ik.imagekit.io/fluid/980191229/images/QLDLH8/QLDLH8_wHAe4zniG.webp?updatedAt=1778619539478",
      variant: 'orange',
      url: '/www/product?id=metabology%E2%84%A2-lean-idMETA-LN-104'
    },
    {
      id: 4,
      name: "Photonic Activator",
      price: "$79.99",
      rv: "35 RV",
      description: "Infuses cells with photonic energy from 84 light-infused minerals—nurturing DNA integrity and telomere health in rhythm with your body's natural vitality.",
      image: "https://ik.imagekit.io/fluid/980191229/images/V5YPRJ/V5YPRJ_R3b99XbLB.webp?updatedAt=1778619627805",
      variant: 'green',
      url: '/www/product?id=metabology%E2%84%A2-photonic-activator-idMETA-PA-105'
    },
    {
      id: 5,
      name: "Metabology™ AM",
      price: "$79.99",
      rv: "35 RV",
      description: "Your morning ignition—natural caffeine from green tea, guarana, and coffee beans fuels clean energy, sharp focus, and metabolic momentum. Buffered by plant-based nutrients to reduce jitters, crashes, and overstimulation—so you rise clear, steady, and ready.",
      image: "https://ik.imagekit.io/fluid/980191229/images/84JV8S/84JV8S_hBTUIh5aG.png?updatedAt=1778619542248",
      variant: 'yellow',
      url: '/www/product?id=metabology-am-idMETA-AM-101'
    },
    {
      id: 6,
      name: "Metabology™ PM",
      price: "$79.99",
      rv: "35 RV",
      description: "Rest easy. Metabology PM calms the body, quiets the mind, and supports your metabolism while you sleep—so you wake restored, aligned, and ready for what's next.",
      image: "https://ik.imagekit.io/fluid/980191229/images/VJ6UVY/VJ6UVY_JNzhOKXOK.webp?updatedAt=1778619583866",
      variant: 'orange',
      url: '/www/product?id=metabology-pm-idMETA-PM-102'
    },
    {
      id: 7,
      name: "Metabology™ AM/PM",
      price: "$143.98",
      rv: "60 RV",
      description: "Your rhythm, refined. From sunrise to deep sleep, this duo fuels your metabolism, balances your energy, and keeps you aligned—day and night.",
      image: "https://ik.imagekit.io/fluid/980191229/images/Y763AQ/Y763AQ_BNi-x2_9F.webp",
      variant: 'green',
      url: '/www/product?id=metabology%E2%84%A2-am%2Bpm-set-idTF1-APP-712'
    },
    {
      id: 8,
      name: "Rose Gold Elixir",
      price: "$126.50",
      rv: "60 RV",
      description: "A ritual of radiance. This luminous blend restores, renews, and reveals your skin's natural brilliance—one sacred drop at a time. Crafted to honor your skin's wisdom, Rose Gold Elixir restores what the day takes and reveals what time cannot touch.",
      image: "https://ik.imagekit.io/fluid/980191229/images/PBR3ML/PBR3ML_uOdaEMGdg.png?updatedAt=1778619651243",
      variant: 'yellow',
      url: '/www/product?id=rose-gold-elixir-idTSC-RGE-202'
    },
    {
      id: 9,
      name: "Charcoal Cleanser",
      price: "$38.50",
      rv: "10 RV",
      description: "Purifying Charcoal Cleanser is a gentle yet powerful formula to transform your cleansing routine into a refreshing ritual of renewal.",
      image: "https://ik.imagekit.io/fluid/980191229/images/WBJBZV/WBJBZV_tO7kUtgFd.png",
      variant: 'orange',
      url: '/www/product?id=purifying-charcoal-cleanser-idTSC-PCC-201'
    },
    {
      id: 10,
      name: "Beauty Collection",
      price: "$247.78",
      rv: "100 RV",
      description: "A two-step ritual of renewal, morning and night: 1) Cleanse with Purifying Charcoal. 2) Illuminate with Rose Gold Elixir. A daily rhythm that honors your skin's wisdom and your soul's cadence—restoring radiance from within.",
      image: "https://ik.imagekit.io/fluid/980191229/images/YY3XZA/YY3XZA_mNc1utXtx.png?updatedAt=1778619546898",
      variant: 'yellow',
      url: '/www/product?id=beauty-collection-idTF2-SCP-722'
    }
  ];

  // Helper method to get proper replicated URL for products
  getReplicatedProductUrl(product: any): string {
    const webAlias = this.userService.userServiceModal?.WebAlias || 'www';
    const baseUrl = window.location.origin;
    return `${baseUrl}/${webAlias}${product.url}`;
  }

  // Navigate to product details page
  navigateToProduct(product: any): void {
    // Extract the query parameter from the URL
    const urlParts = product.url.split('?');
    const queryString = urlParts[1];
    
    // Parse the query parameters
    const queryParams: any = {};
    if (queryString) {
      const params = new URLSearchParams(queryString);
      params.forEach((value, key) => {
        queryParams[key] = value;
      });
    }
    
    // Navigate to the product page with query parameters
    this.router.navigate(['/product'], { queryParams });
  }

  // Product features data
  productFeatures: any[] = [
    {
      title: "Awaken your cells",
      description: "with Metabology AM to spark metabolism and morning vitality.",
      type: 'alarm'
    },
    {
      title: "Unwind deeply",
      description: "with Metabology PM to restore the rhythm of restful, regenerative sleep.",
      type: 'moon'
    },
    {
      title: "Stay sharp",
      description: "with Metabology Ω3 for optimal heart, mind, and metabolic performance.",
      type: 'brain'
    },
    {
      title: "Radiate from within",
      description: "and let the Beauty Set reveal your skin's natural brilliance.",
      type: 'sunshine'
    },
    {
      title: "Get shredded",
      description: "with Metabology Lean to help oxidize fat and develop lean muscle.",
      type: 'weight'
    },
    {
      title: "Switch on DNA integrity and telomere resilience",
      description: "with light-infused minerals that celebrate cellular excellence.",
      type: 'lightbulb'
    }
  ];

   ngOnInit(): void {
    window.scroll(0,0);
    this.createScrollContent();
    this.createSecondScrollContent();
    // Set up Vimeo embed URL - autoplay, muted, loop, with controls visible
    // Added responsive=1 for better mobile support and controls=1 for playback controls
    const vimeoId = '1152017844';
    this.vimeoEmbedUrl = this.sanitizer.bypassSecurityTrustResourceUrl(
      `https://player.vimeo.com/video/${vimeoId}?autoplay=1&muted=1&loop=1&playsinline=1&responsive=1&controls=1&title=0&byline=0&portrait=0`
    );

    // Set up testimonial Vimeo embed URL - autoplay, muted, loop, with controls visible
    const testimonialVimeoId = '1156932382';
    this.testimonialVimeoEmbedUrl = this.sanitizer.bypassSecurityTrustResourceUrl(
      `https://player.vimeo.com/video/${testimonialVimeoId}?autoplay=1&muted=1&loop=1&playsinline=1&responsive=1&controls=1&title=0&byline=0&portrait=0`
    );
   }

  createScrollContent(): void {
    const phrases = [
      "Welcome to Tangerine.fun™",
      "Where Life is Juicy",
      "Wellness with a Wink",
      "Beauty with a Bounce",
      "Find Your Fun"
    ];
    
    this.scrollContent = [];
    for (let i = 0; i < 6; i++) { // Repeat 6 times to ensure no gaps
      phrases.forEach((phrase, index) => {
        this.scrollContent.push({
          phrase: phrase,
          key: `scroll-${i}-${index}`
        });
      });
    }
  }

  createSecondScrollContent(): void {
    const phrases = [
      "Energize Your Health",
      "Own Your Metabolism",
      "Glow From Within",
      "Awaken Your Wellness",
      "Experience The Power"
    ];
    
    this.secondScrollContent = [];
    for (let i = 0; i < 6; i++) { // Repeat 6 times to ensure no gaps
      phrases.forEach((phrase, index) => {
        this.secondScrollContent.push({
          phrase: phrase,
          key: `second-scroll-${i}-${index}`
        });
      });
    }
  }

  getVariantColor(variant: string): string {
    const variantColors = {
      green: '#677240',
      yellow: '#F09F53',
      orange: '#F18021'
    };
    return variantColors[variant as keyof typeof variantColors] || '#677240';
  }  
  ngAfterViewInit():void {
    this.config = {
      mousewheel:false,
      observer: true,
      slidesPerView: 1,
      spaceBetween: 10,
      keyboard: true,
      navigation: true,
      pagination: false,
      grabCursor: true,
      loop: true,
      preloadImages: true,
    };

    // Ensure video plays after view init
    setTimeout(() => {
      this.playVideo();
    }, 100);
      
    // Select multiple sections by their IDs or classes
  const childDivId = this.topProductComponent?.targetDivId || 'top-products-details';
const targetSections = document.querySelectorAll('.top-products-details, #discover-more-quote, #exp-freedom-text-section, .testimonial-cards, #loyality-reward-program,#bottom-section123');

// Create an observer
const observer = new IntersectionObserver((entries) => {
  entries.forEach(entry => {
    if (entry.isIntersecting) {
      switch (entry.target.id || entry.target.className) {

        case 'discover-more-quote':
          document.getElementById('discover-hidden-content').classList.add('animate-zoomIn');
          break;

        case 'exp-freedom-text-section':
          document.getElementById('exp-freedom-text-section').classList.add('animate-slideInLeft');
          break;

        case 'loyality-reward-program':
          document.getElementById('loyality-reward-program').style.opacity = '0.95';
          break;
        case 'bottom-section123':
          document.getElementById('bottom-section123').classList.add('animate-slideInUp');
          break;
      }

      // If it's the testimonial cards section, apply animation to each card individually
      if (entry.target.classList.contains('testimonial-cards')) {
        document.querySelectorAll('.testimonial-cards').forEach((element) => {
          element.classList.add('animate-slideInUp');
        });
      }

      if (entry.target.classList.contains('top-products-details')) {
        document.getElementById(`${childDivId}`)?.classList.add('animate-zoomIn');
      }

      // Stop observing this section after the animation is applied to prevent it from re-triggering
      observer.unobserve(entry.target);
    }
  });
}, { threshold: 0.5 });

// Observe each section
targetSections.forEach(section => {
  observer.observe(section);
});

    // Add intersection observer for Vimeo videos to trigger autoplay
    setTimeout(() => {
      const vimeoVideo2 = document.getElementById('vimeoVideo2');
      const vimeoTestimonial = document.getElementById('vimeoTestimonial');

      const vimeoObserver = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            const iframe = entry.target as HTMLIFrameElement;
            // Use Vimeo Player API to trigger play
            iframe.contentWindow?.postMessage('{"method":"play"}', '*');
          }
        });
      }, { threshold: 0.5 });

      if (vimeoVideo2) vimeoObserver.observe(vimeoVideo2);
      if (vimeoTestimonial) vimeoObserver.observe(vimeoTestimonial);
    }, 500);

  }

  NavigateToDiscoverProducts(redirection){
    this.router.navigate([redirection]);
  }

  isLoggedIn() {
    if (
      Object.keys(this.userService.userServiceModal.customerData).length &&
      this.userService.userServiceModal.customerData.CustomerId &&
      this.userService.checkIfUserAuthenticatedOrNot()
    ) {
      return true;
    } else {
      return false;
    }
  }

  // Navigate to appropriate shop based on login status
  navigateToShop() {
    if (this.isLoggedIn()) {
      // Logged in users go to marketplace
      this.router.navigate(['/marketplace']);
    } else {
      // Non-logged in users go to main store
      this.router.navigate(['/shop']);
    }
  }

  // Video play methods
  onVideoLoaded(): void {
    this.playVideo();
  }

  onVideoCanPlay(): void {
    this.playVideo();
  }

  playVideo(): void {
    if (this.heroVideo && this.heroVideo.nativeElement) {
      const video = this.heroVideo.nativeElement;
      video.muted = true;
      video.play().catch((error: any) => {
        console.log('Video autoplay prevented:', error);
        // Try again after a short delay
        setTimeout(() => {
          video.play().catch(() => {
            console.log('Video play failed after retry');
          });
        }, 500);
      });
    }
  }

  // Show video controls on hover
  showVideoControls(event: any): void {
    if (event.target) {
      event.target.controls = true;
    }
  }

  // Hide video controls when not hovering
  hideVideoControls(event: any): void {
    if (event.target) {
      event.target.controls = false;
    }
  }
}
